import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function CircleTickIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="4 4 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7.586 12L11 15.414L16.414 10L15 8.586L11 12.586L9 10.586L7.586 12Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20C7.589 20 4 16.411 4 12ZM6 12C6 15.309 8.691 18 12 18C15.309 18 18 15.309 18 12C18 8.691 15.309 6 12 6C8.691 6 6 8.691 6 12Z"
        />
      </svg>
    </Icon>
  );
}
